/* eslint-disable max-len */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { css } from 'aphrodite';
import ReactPaginate from 'react-paginate';
import qs from 'qs';

import styles from './styles.js';

import Translatable from '../../../../../../components/Translatable';

class Pagination extends Component {
    shouldComponentUpdate(nextProps) {
        const { currentPage, roomCount } = this.props;
        if (Number(currentPage) !== Number(nextProps.currentPage)) {
            return true;
        }
        if (roomCount !== nextProps.roomCount) {
            return true;
        }
        return false;
    }

    handlePageClick = e => {
        const { handlePageClick } = this.props;
        const location = decodeURIComponent(window.location.pathname.split('/')[4]);
        const tag = {
            quick_slug: decodeURIComponent(window.location.pathname.split('/')[3])
        };
        const params = qs.parse(window.location.search.split('?')[1]);
        params.page = e.selected + 1;
        handlePageClick(location, tag, qs.stringify(params, { arrayFormat: 'brackets' }));
    }

    render() {
        const { handlePageClick } = this;
        const { currentPage, resultsFrom, resultsTo, roomCount, showAllPages, totalPages } = this.props;
        return (
            <div className={css(styles.centerContainer)}>
                <ReactPaginate
                    previousLabel={
                        <div className={css(styles.chevronButton)}>
                            <div className={css(styles.chevronContainer)}>
                                <svg
                                    viewBox="0 0 18 18"
                                    role="img"
                                    aria-label="Previous"
                                    focusable="false"
                                    style={{
                                        display: 'block',
                                        fill: 'currentcolor',
                                        height: '1em',
                                        width: '1em'
                                    }}
                                >
                                    <path
                                        fillRule="evenodd"
                                        d="M13.703 16.293a1 1 0 1 1-1.415 1.414l-7.995-8a1 1 0 0 1 0-1.414l7.995-8a1 1 0 1 1 1.415 1.414L6.413 9l7.29 7.293z"
                                    />
                                </svg>
                            </div>
                        </div>
                    }
                    previousClassName={
                        Number(currentPage) === 1 ?
                            css(styles.hiddenButtonContainer) :
                            css(styles.buttonContainer)
                    }
                    previousLinkClassName={css(styles.link)}
                    nextLabel={
                        <div className={css(styles.chevronButton)}>
                            <div className={css(styles.chevronContainer)}>
                                <svg
                                    viewBox="0 0 18 18"
                                    role="img"
                                    aria-label="Next"
                                    focusable="false"
                                    style={{
                                        display: 'block',
                                        fill: 'currentcolor',
                                        height: '1em',
                                        width: '1em'
                                    }}
                                >
                                    <path
                                        fillRule="evenodd"
                                        d="M4.293 1.707A1 1 0 1 1 5.708.293l7.995 8a1 1 0 0 1 0 1.414l-7.995 8a1 1 0 1 1-1.415-1.414L11.583 9l-7.29-7.293z"
                                    />
                                </svg>
                            </div>
                        </div>
                    }
                    nextClassName={
                        Number(currentPage) === Number(totalPages) ?
                            css(styles.hiddenButtonContainer) :
                            css(styles.buttonContainer)
                    }
                    nextLinkClassName={css(styles.link)}
                    breakLabel={
                        <div className={css(styles.ellipsis)}>
                            <div className={css(styles.text, styles.size_regular, styles.weight_light)}>
                                …
                            </div>
                        </div>
                    }
                    breakClassName={css(styles.buttonContainer)}
                    pageCount={totalPages}
                    forcePage={Number(currentPage) - 1}
                    marginPagesDisplayed={(showAllPages ? totalPages : 2)}
                    pageRangeDisplayed={(showAllPages ? totalPages : 2)}
                    onPageChange={handlePageClick}
                    containerClassName={css(styles.buttonList)}
                    pageClassName={css(styles.buttonContainer, styles.numberContainer)}
                    pageLinkClassName={css(styles.link)}
                    activeClassName={css(styles.numberContainer, styles.numberContainer_selected)}
                />
                <div style={{ marginTop: '8px' }}>
                    <Translatable
                        content={{
                            transKey: 'search.results',
                            count: roomCount,
                            replacements: {
                                lower: resultsFrom,
                                upper: resultsTo,
                                total: roomCount
                            }
                        }}
                    />
                </div>
            </div>
        );
    }
}

Pagination.propTypes = {
    currentPage: PropTypes.number.isRequired,
    handlePageClick: PropTypes.func.isRequired,
    resultsFrom: PropTypes.number.isRequired,
    resultsTo: PropTypes.number.isRequired,
    roomCount: PropTypes.number.isRequired,
    showAllPages: PropTypes.bool.isRequired,
    totalPages: PropTypes.number.isRequired
};

export default Pagination;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/SearchContent/SearchResults/Pagination/Pagination.jsx